var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:{ 'black' : _vm.black}},[_c('header-block',{attrs:{"black":_vm.black}}),_c('router-view'),_c('div',{staticClass:"footer"},[_c('h1',{staticClass:"link type--display_1",on:{"click":function($event){_vm.revertColor()}}},[_vm._v("Revert Color")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a97a4124","hasScoped":false,"transformToRequire":{"video":"src","source":["src","srcset"],"vector":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = lr+p
// module chunks = 1